<template>

  <div class="generic-container">
      
    <header :class="[{ fadeIn: stateManager.animationEnabled}, 'bgBase', 'xs' ]">
      <h1>Il tuo profilo</h1>
    </header>

    <div class="salmoContent" v-if="isAuthenticated">

      <div class="intro">
        <h2>Benvenuto {{ user.name }}</h2>
        <p>Qui puoi modificare le impostazioni riferite al tuo profilo.</p>
      </div>

      <h3>Scegli il tuo avatar</h3>
      <p>Puoi scegliere il tuo avatar cliccando in di questi disponibili sotto. 
        Non è ancora possibile caricare un avatar personalizzato.</p>

        <ul class="avatars">
          <li class="selected"><img src="https://cdn4.iconfinder.com/data/icons/pop-avatars/1000/animals_accounts_avatars___user_account_avatar_animal_pet_cat_feline-256.png" alt=""></li> <!-- NON è gratis-->
          <li><img src="https://cdn2.iconfinder.com/data/icons/itty-bitty-animal-avatars/128/elephant_05-01-1024.png" alt=""></li> <!-- NON è gratis-->
          <li><img src="https://cdn1.iconfinder.com/data/icons/user-pictures/100/female1-512.png" alt=""></li> <!-- è gratis-->
        </ul>

      <h3>Effettua la disconnessione</h3>
      <button @click="logoutWithParams">Esci</button>

      <h3>Elimina il tuo account</h3>
      <p>Questa operazione non è reversibile e cancellera tutti i tuoi dati dall'applicazione.</p>
      <button class="danger" @click="logoutWithParams">Cancella il mio account</button>
    </div>

  </div>

</template>

<script setup>
import { updatePageDescription, updatePageTitle } from '@/libs/utils';
import { stateManager } from '@/stateManager';
import { useAuth0 } from '@auth0/auth0-vue';
import { onMounted } from 'vue';
const { user, isAuthenticated, logout  } = useAuth0();

onMounted(() => {
  updatePageTitle(document, `Account`);
  updatePageDescription(document, '');
})

function logoutWithParams() {
  logout({ logoutParams: { returnTo: 'http://localhost:8080'}})
}
</script>

<style scoped lang="scss">
  h1, h2, h3, h4 { margin-bottom: 0; }
  p { margin-top: .5rem;}
  .intro { margin-bottom: 2.3rem; }
  button { margin-top: .4rem; }

  ul.avatars {
    list-style: none;
    display: flex;
    margin: 0; padding: 0;


    li {
      margin: 0; padding: 0;

      &.selected img { border: 3.7px solid #ffee58; }
      &.selected img:hover { border: 3.7px solid #ffee58; }

      img {
        border-radius: 50%;
        border: 3.7px solid #ccc;
        cursor: pointer;
        width: 50px; height: auto;
        margin-right: .5rem;
        transition: border .3s;

        &:hover { border: 3.7px solid #888;}
      }
    }
  }
</style>